import { NativeActionNames } from '@wix/editor-platform-host-integration-apis';
import type {
  Actions,
  Action,
  DashboardAction,
} from '@wix/component-protocol/schema';
import {
  CustomizedNativeManifestAction,
  CustomizedDashboardManifestAction,
  EditActionsDictionary,
} from '../types';

type CustomizedManifestAction =
  | CustomizedNativeManifestAction
  | CustomizedDashboardManifestAction;

export type GroupedNativeActions = {
  nativeActions: EditActionsDictionary<Action | DashboardAction>;
  customizedNativeActions: EditActionsDictionary<CustomizedManifestAction>;
};

const isCustomizedNativeManifestAction = (
  action: Action | DashboardAction,
): action is CustomizedManifestAction => {
  return 'displayName' in action || 'execution' in action;
};

export function groupNativeActions(
  nativeActions: Actions,
): GroupedNativeActions {
  return (
    Object.entries(nativeActions) as [
      NativeActionNames,
      Action | DashboardAction,
    ][]
  ).reduce<GroupedNativeActions>(
    (acc: GroupedNativeActions, [actionName, action]) => {
      if (action.hidden) {
        return acc;
      }
      if (isCustomizedNativeManifestAction(action)) {
        acc.customizedNativeActions[actionName] = action;
      } else {
        acc.nativeActions[actionName] = action;
      }
      return acc;
    },
    {
      nativeActions: {},
      customizedNativeActions: {},
    },
  );
}
